<template>
  <div>
    <!-- 发票比例设置 -->
    <el-dialog :title="$t('message.invoiceScaleSetting')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <!--发票： -->
        <div class="label">{{ $t("message.invoiceRatio") }}% ：</div>
        <div class="val">
          <el-input v-model="detail.invoice_rate" onfocus="this.select()" placeholder="请输入发票比例" type="number"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        invoice_rate: this.detail.invoice_rate,
      };
      this.$api.clienteleApi.setInvoiceRate(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>